<template>
  <div class="_make-article">
    
    <header class="ArticleMainHeader">
      <h1 class="ArticleMainTitle">การจัดการบอท - กำหนดรูปภาพของบอท</h1>
    </header>
    <div class="MarkdownContent">
      <p class="preindent">เป็น API ที่ใช้สำหรับการกำหนด แก้ไขเปลี่ยนแปลง รูปภาพประจำตัวของบอท </p>


    </div>

    <header class="EndpointHeader">
      <h2 class="EndpointTitle">
        API กำหนด แก้ไขเปลี่ยนแปลง รูปภาพประจำตัวของบอท
      </h2>
      -
      <span class="EndpointVerbPost">
        POST
      </span>
      <span class="EndpointUrl">
        {{urleditpicbot}}
      <v-icon class="urlcopy" style="color:black; font-size: 13px !important; cursor: pointer;" v-clipboard:copy="urleditpicbot">file_copy</v-icon>
      </span>

    </header>

    <div class="MarkdownContent hidden-sm-and-down">
      <!-- <p class="preindent">ทุกครั้งที่ทำการติดต่อ API กับทางOneChat ต้องส่ง Authorization มาใน Header ทุกครั้ง </p> -->
      <h3>Request Parameter</h3>
      <!--  <v-btn type="button"
      v-clipboard:copy="message">Copy text</v-btn> -->
      <code class="codecolor" style="">
        <v-tooltip top >
<v-btn flat icon type="button" class="requestfile" style="float: right;cursor: pointer;" slot="activator" v-clipboard:copy="message">
      <v-icon style="color:white; font-size: 16px !important;">file_copy</v-icon></v-btn>
       <span>Copy to clipboard</span>
    </v-tooltip>
  {
    <span class="colorkey">"token_bot"</span> : <span class="colorvalue">"B5b1fxxxxxx94fxxxxx594xxxxe763xxxx"</span>,
    <span class="colorkey">"file"</span> : <span class="colorvalue">Object.file</span>
  }
      </code>

      <h3>รายละเอียดข้อมูลที่ใช้ในการส่ง Request</h3>
      <table id="apifiletable" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>token_bot</td>
          <td>String</td>
          <td>Token ของบอท</td>
        </tr>
        <tr>
          <td>file</td>
          <td>Object.file</td>
          <td>ไฟล์ภาพที่ต้องการอัพโหลดขึ้นเป็นรูปประจำตัวบอท</td>
        </tr>
      </table>


      <h3>Response</h3>
     
<code class="codecolor">
<v-tooltip top >
<v-btn flat icon type="button" class="responsefile" style="float: right;cursor: pointer;" slot="activator" v-clipboard:copy="messageresponsefile">
      <v-icon style="color:white; font-size: 16px !important;">file_copy</v-icon></v-btn>
       <span>Copy to clipboard</span>
    </v-tooltip>
  {
    <span class="colorkey">"filename"</span> : <span class="colorvalue">"https://chat.one.th/Testbot3.jpg"</span>,
    <span class="colorkey">"owner"</span> : <span class="colorvalue">"B5b1fxxxxxx94fxxxxx594xxxxe763xxxx"</span>,
    <span class="colorkey">"message"</span> : <span class="colorvalue">"upload success..."</span>,
    <span class="colorkey">"status"</span> : <span class="colorvalue">"success"</span>
  }
</code>


<h3>รายละเอียดข้อมูลที่ได้จาก Response</h3>
      <table id="apifiletable" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>filename</td>
          <td>String</td>
          <td>ลิ้งของไฟล์รูปที่ทำการอัพโหลด</td>
        </tr>
        <tr>
          <td>owner</td>
          <td>String</td>
          <td>Token ของบอทที่ทำการเปลี่ยนแปลงรูปประจำตัว</td>
        </tr>
        <tr>
          <td>message</td>
          <td>String</td>
          <td>ข้อความแสดงสถานะทั้งสำเร็จและไม่สำเร็จ</td>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>1. success แสดงว่าการทำงานใน API นั้นสำเร็จ<br>
          2. fail แสดงว่าการทำงานใน API นั้นไม่สำเร็จ
          </td>
        </tr>
      </table>
    </div>

    <!-- mobile -->

    <div class="MarkdownContent hidden-md-and-up">
      <!-- <p class="preindent">ทุกครั้งที่ทำการติดต่อ API กับทางOneChat ต้องส่ง Authorization มาใน Header ทุกครั้ง </p> -->
      <h3>Request Parameter</h3>
      <!--  <v-btn type="button"
      v-clipboard:copy="message">Copy text</v-btn> -->
      <code class="codecolormo" style="">
        <v-tooltip top >
<v-btn flat icon type="button" class="requestfile" style="float: right;cursor: pointer;" slot="activator" v-clipboard:copy="message">
      <v-icon style="color:white; font-size: 16px !important;">file_copy</v-icon></v-btn>
       <span>Copy to clipboard</span>
    </v-tooltip>
  {
    <span class="colorkey">"token_bot"</span> : <span class="colorvalue">"B5b1fxxxxxx94fxxxxx594xxxxe763xxxx"</span>,
    <span class="colorkey">"file"</span> : <span class="colorvalue">Object.file</span>
  }
      </code>

      <h3>รายละเอียดข้อมูลที่ใช้ในการส่ง Request</h3>
      <table id="apifiletablemo" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>token_bot</td>
          <td>String</td>
          <td>Token ของบอท</td>
        </tr>
        <tr>
          <td>file</td>
          <td>Object.file</td>
          <td>ไฟล์ภาพที่ต้องการอัพโหลดขึ้นเป็นรูปประจำตัวบอท</td>
        </tr>
      </table>


      <h3>Response</h3>
     
<code class="codecolormo">
<v-tooltip top >
<v-btn flat icon type="button" class="responsefile" style="float: right;cursor: pointer;" slot="activator" v-clipboard:copy="messageresponsefile">
      <v-icon style="color:white; font-size: 16px !important;">file_copy</v-icon></v-btn>
       <span>Copy to clipboard</span>
    </v-tooltip>
  {
    <span class="colorkey">"filename"</span> : <span class="colorvalue">"https://chat.one.th/Testbot3.jpg"</span>,
    <span class="colorkey">"owner"</span> : <span class="colorvalue">"B5b1fxxxxxx94fxxxxx594xxxxe763xxxx"</span>,
    <span class="colorkey">"message"</span> : <span class="colorvalue">"upload success..."</span>,
    <span class="colorkey">"status"</span> : <span class="colorvalue">"success"</span>
  }
</code>


<h3>รายละเอียดข้อมูลที่ได้จาก Response</h3>
      <table id="apifiletablemo" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>filename</td>
          <td>String</td>
          <td>ลิ้งของไฟล์รูปที่ทำการอัพโหลด</td>
        </tr>
        <tr>
          <td>owner</td>
          <td>String</td>
          <td>Token ของบอทที่ทำการเปลี่ยนแปลงรูปประจำตัว</td>
        </tr>
        <tr>
          <td>message</td>
          <td>String</td>
          <td>ข้อความแสดงสถานะทั้งสำเร็จและไม่สำเร็จ</td>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>1. success แสดงว่าการทำงานใน API นั้นสำเร็จ<br>
          2. fail แสดงว่าการทำงานใน API นั้นไม่สำเร็จ
          </td>
        </tr>
      </table>
    </div>
    
  </div>
</template>

<script>
import Navbar from '@/components/home/Navbar'
export default {
  components: {
    Navbar
  },
  data: () => ({
    urleditpicbot: '',
    message: '{\n\t"token_bot":"B5b1fxxxxxx94fxxxxx594xxxxe763xxxx",\n\t"file": Object.file\n}',
    messageresponsefile: '{\n\t"filename" : "https://chat.one.th/Testbot3.jpg",\n\t"owner" : "B5b1fxxxxxx94fxxxxx594xxxxe763xxxx",\n\t"message" : "upload success...",\n\t"status" : "success"\n}'
    // items: [
    //   {src: '/static/image/ios_photo/ios_friend.png'},
    //   {src: '/static/image/ios_photo/ios_login.png'}
    // ]
  }),
  methods: {

  },
  created () {
    this.urleditpicbot = process.env.APImanage + '/api/setpictureprofilebot'
  }
}
</script>

<style type="text/css" scoped>
.codecolor {
  background: #2c3538;
  color: white;
  width: 40vw;
}
.codecolormo {
  background: #2c3538;
  color: white;
  width: 90vw;
}
.colorkey {
  color:#65ef01;
}
.colorvalue {
  color:#ffee6a;
}
.preindent {
  text-indent: 2em;
}
._make-article {
    line-height: 1.5em;
    width: 90vw;
}
.ArticleMainTitle {
    margin-top: 0;
    font-size: 2.25rem;
    line-height: 1em;
}
._make-article h1, ._make-article h2, ._make-article h3, ._make-article h4, ._make-article h5, ._make-article h6 {
    margin-top: 32px;
    margin-bottom: 24px;
}
.EndpointHeader h2 {
  margin-top: 2vh;
    margin-bottom: 1vh;
}
.EndpointHeader {
    margin-top: 2vh;
    margin-bottom: 2vh;
}
.EndpointTitle {
    display: inline-block;
    margin: 0;
}
.EndpointVerbGet {
    /*position: relative;*/
    top: -2px;
    display: inline-block;
    padding: 4px 6px;
    border: 1px solid #D5DDE5;
    font-size: 0.75rem;
    font-weight: bold;
    line-height: 1em;
    border-radius: 4px;
    border-color: #134fe0;
    background-color: #215CEC;
    color: #FFFFFF;
}
.EndpointVerbPost {
    /*position: relative;*/
    top: -2px;
    display: inline-block;
    padding: 4px 6px;
    border: 1px solid #D5DDE5;
    font-size: 0.75rem;
    font-weight: bold;
    line-height: 1em;
    border-radius: 4px;
    border-color: #3cb614;
    background-color: #44CD16;
    color: #FFFFFF;
}
.EndpointUrl {
    display: block;
    color: #6D7D8D;
    /*cursor: pointer;*/
}
#apifiletable {
    font-family: 'CS ChatThaiUI' !important;
    border-collapse: collapse;
    width: 40vw;
}

#apifiletable td, #apifiletable th {
    border: 1px solid #ddd;
    padding: 8px;
}

#apifiletable tr:nth-child(even){background-color: #f2f2f2;}

#apifiletable tr:hover {background-color: #ddd;}

#apifiletable th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: center;
    background-color: #000;
    color: white;
}


#apifiletablemo {
    font-family: 'CS ChatThaiUI' !important;
    border-collapse: collapse;
    width: 100%;
}

#apifiletablemo td, #apifiletablemo th {
    border: 1px solid #ddd;
    padding: 8px;
}

#apifiletablemo tr:nth-child(even){background-color: #f2f2f2;}

#apifiletablemo tr:hover {background-color: #ddd;}

#apifiletablemo th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: center;
    background-color: #000;
    color: white;
}


/*.divbutton {
    height: 30px;
    background: #000;
}*/

.requestfile {
    display: none !important;
}

.codecolor:hover .requestfile {
    display: block !important;
}

.urlcopy {

    display: none !important;
}
.EndpointUrl:hover .urlcopy {
    display: inline !important;
}
.responsefile{
    display: none !important;
}

.codecolor:hover .responsefile {
    display: block !important;
}
#apimsgtablemo {
    font-family: 'CS ChatThaiUI' !important;
    border-collapse: collapse;
    width: 100%;
}

#apimsgtablemo td, #apimsgtablemo th {
    border: 1px solid #ddd;
    padding: 8px;
}

#apimsgtablemo tr:nth-child(even){background-color: #f2f2f2;}

#apimsgtablemo tr:hover {background-color: #ddd;}

#apimsgtablemo th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: center;
    background-color: #000;
    color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/home/api/managebot_editpicture.vue